import validator from 'validator';
import gsap from "gsap";
import axios from "axios";
import GgCaptcha from "../../../libs/ggCaptcha";

class FeatureContactForm {
    constructor() {
        this.DOM = {
            form: document.querySelector('.js-featureContact_main_form')
        };

        if (!this.DOM.form) return;
        this.DOM.message = this.DOM.form.querySelector('.js-message');

        this.formInput = {
            name: this.DOM.form.querySelector('[name="name"]'),
            company: this.DOM.form.querySelector('[name="company"]'),
            position: this.DOM.form.querySelector('[name="position"]'),
            email: this.DOM.form.querySelector('[name="email"]'),
            message: this.DOM.form.querySelector('[name="message"]'),
            btnSubmit: this.DOM.form.querySelector('button[type="submit"]')
        };

        this.bindEvent();
    }

    hasError(filed) {
        filed.parentElement.classList.add('has--error');
    }

    removeError(filed) {
        filed.parentElement.classList.remove('has--error', 'focus');

    }

    resetFormSubmit() {
        this.DOM.form.reset();
        this.DOM.form.querySelectorAll('input, textarea').forEach(input => {
            this.removeError(input);
            input.dispatchEvent(new Event('blur'));
        });
        this.DOM.form.querySelectorAll('select').forEach(select => select.dispatchEvent(new CustomEvent('reset')));
    }

    sending(text) {

        this.DOM.message.classList.remove('success');
        this.DOM.message.classList.remove('fail');

        this.DOM.message.textContent = text;
    }

    success(text) {
        this.DOM.message.classList.add('success');
        this.DOM.message.textContent = text;
    }

    fail(text) {
        this.DOM.message.classList.add('fail');
        this.DOM.message.textContent = text;
    }

    bindEvent() {

        this.DOM.form.addEventListener('submit', (event) => {
            event.preventDefault();
            if (this.stopSubmit) return;

            let errors = 0;

            if (validator.isEmpty(this.formInput.name.value)) {
                errors++;
                this.hasError(this.formInput.name);
            } else {
                this.removeError(this.formInput.name);
            }

            if (!validator.isEmail(this.formInput.email.value)) {
                errors++;
                this.hasError(this.formInput.email);
            } else {
                this.removeError(this.formInput.email);
            }
            if (validator.isEmpty(this.formInput.message.value)) {
                errors++;
                this.hasError(this.formInput.message);
            } else if (!validator.isByteLength(this.formInput.message.value, 0, 1500)) {
                errors++;
                this.hasError(this.formInput.message);
            }

            if (errors === 0) {

                this.DOM.form.style.pointerEvents = 'none';
                gsap.to(this.formInput.btnSubmit, {opacity: 0, ease: 'power3.out', duration: .5});
                gsap.to(this.DOM.message, {opacity: 1, ease: 'power3.out', duration: .5});
                this.stopSubmit = true;
                this.sending('Sending...');

                GgCaptcha.createGGToken((token) => {

                    let _form = new FormData(this.DOM.form);
                    _form.append('action', 'send_contact_mail');
                    _form.append('ggToken', token);

                    axios.post(wpData.ajaxUrl, _form)
                        .then(({data}) => {
                            if (data.success) {
                                this.success(data.success.message);
                            } else {
                                this.fail(data.errors[0]);
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        }).finally(() => {
                        this.resetFormSubmit();
                        this.stopSubmit = false;

                        setTimeout(() => {
                            this.DOM.form.style.pointerEvents = 'auto';
                            gsap.to(this.formInput.btnSubmit, {opacity: 1, ease: 'power3.out', duration: .5});
                            gsap.to(this.DOM.message, {opacity: 0, ease: 'power3.out', duration: .5});
                        }, 2000);
                    });
                });
            }

        });
    }
}

export default FeatureContactForm;